import { Box, useTheme } from "@mui/system";
import { useParams } from "react-router-dom";
import PeopleSearchMeetingsView from "./PeopleSearchMeetingsView";
import { Tab, Tabs, Typography } from "@mui/material";
import PeopleSearchActionItemsView from "./PeopleSearchActionItemsView";
import { useState, useEffect } from "react";
import arrowBackSvg from "../../assets/common/arrow-back.svg";
import { useLocation, useNavigate } from "react-router-dom";


const GlobalSearchPeoplePage = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { profile_org_id, tab} = useParams<{ profile_org_id: string; tab: string}>();
  const [activeTab, setActiveTab] = useState<number>(0);
  const personName = sessionStorage.getItem('peopleData');
  const location = useLocation();
  const is_team_meeting_id = location.state?.is_team_meeting_id ?? false;
  const email = location.state?.email ?? "";

  useEffect(() => {
    // Set the active tab based on the URL's tab value
    if (tab === 'meetings') {
      setActiveTab(0);
    } else if (tab === 'action-items') {
      setActiveTab(1);
    } else {
      // If the tab value is invalid, redirect to the default tab 'meetings'
      navigate(`/peoplemeetings/${profile_org_id}/meetings`,{
        state: {
          is_team_meeting_id: is_team_meeting_id,
        }
      });
    }
  }, [tab]);

  const handleTabChange = (_event: React.ChangeEvent<object>, newValue: number) => {
    setActiveTab(newValue);
    // Update the URL based on the selected tab
    const newTab = newValue === 0 ? 'meetings' : 'action-items';
    navigate(`/peoplemeetings/${profile_org_id}/${newTab}`,{
      state: {
        assignee_email_id: email,
        is_team_meeting_id: is_team_meeting_id,
      }
    });
  };
  const handleBack = () => {
    if (activeTab === 0) {
      navigate('/meetings/my');
    } else if (activeTab === 1) {
      navigate('/tasks/all-tasks');
    } else{
    const previousPage = sessionStorage.getItem('previousPage');
    if (previousPage) {
      navigate(previousPage);
    } else {

      navigate('/home');
    }
  }
  };

  return (
    <Box className="">
      <Box
        sx={{
          height: "100%",
          padding: "15px",
          [theme.breakpoints.down("lg")]: {
            padding: "10px",
          },
          border: `2px solid ${theme.palette.secondary.main}`,
          borderRadius: "22px",
          background: "#FFFFFF",
        }}
      >
        <Box className="flex flex-row justify-start items-center gap-2 cursor-pointer"
          onClick={handleBack}>
          <img src={arrowBackSvg} />
          <Typography variant="h3"  >
            Search results for -"{personName}"
          </Typography>
        </Box>
        <Tabs value={activeTab} onChange={handleTabChange} aria-label="Meeting and Client Tabs"
        className="app-tabs-container"
          sx={{ marginTop: "-5px" }}
        >
          <Tab label="Interactions" />
          <Tab label="Tasks" />
        </Tabs>
        <Box className="flex flex-col justify-start">
          {activeTab === 0 && <PeopleSearchMeetingsView personEmail={email as string} profileOrgId = {profile_org_id} />}
          {activeTab === 1 && <PeopleSearchActionItemsView personEmail={email as string} profileOrgId = {profile_org_id} />}
        </Box>
      </Box>
    </Box>
  );
};

export default GlobalSearchPeoplePage;